import React, { useEffect, useState } from 'react'

import Footer from './Footer';
import { Link, useLocation } from 'react-router-dom';
import HomeNav from './Navbars/HomeNav';
import fbQR from '../images/facebookQrCode.png'
import wpQR from '../images/wpQr.png'
import NewHomeNav from './Navbars/NewHomeNav';
import NewFooter from './NewFooter';

export default function ContactUs() {
  const [isScrolled, setIsScrolled] = useState(false);

 
  
    // Track scrolling
    useEffect(() => {
      const handleScroll = () => {
        setIsScrolled(window.scrollY > 50); // Adjust the value to when you want the effect
      };
  
      window.addEventListener("scroll", handleScroll);
  
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }, []);
  
    // Scroll to the top
    const scrollToTop = () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    };
    const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);
  return (
    <div className=' '>
      <NewHomeNav/>

      <section >
        <h1 className='bg-gray-200 text-gray-600 font-bold text-center  text-3xl px-5 py-16'>Contact Us</h1>
        

        <div className='mt-10 px-[100px] lg:px-5 flex xl:flex-wrap 2xl:m-auto  gap-10 py-10'>
          <div className='w-[50%] 2xl:m-auto 2xl:w-[100%]   border shadow-lg border-gray-300 p-5 rounded-lg '>
           

          <div className='flex justify-between  items-center'>
            <div className='mt-3'>
              <img src={fbQR} className='w-[250px]' alt="" />
              <Link className='text-blue-600 underline ml-3' to={'https://www.facebook.com/groups/2708905909353211'}>Facebook</Link>
            </div>
            <div>
              <img src={wpQR} className='w-[326px] ' alt="" />
<div className='-mt-[30px] ml-12 xm:-mt-5 xm:ml-5'>
                <p className='text-gray-600 xm:mt-3'>+971 50 556 6411</p>
  
</div>
              </div>

          </div>
          
          </div>

          <div className="w-[50%] 2xl:w-[100%] 2xl:m-auto text-center border shadow-lg border-gray-300 p-5 rounded-lg">
     <iframe className='w-full h-full' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3608.255807509094!2d55.328992974969985!3d25.261978829074494!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f5d722df49f75%3A0x8fbdb0714974a65f!2sHappy%20Marine%20Shipping%20LLC!5e0!3m2!1sen!2sae!4v1728160374591!5m2!1sen!2sae" frameborder="0"></iframe>
    </div>

        </div>

        {/* Go to Top Button */}
        {isScrolled && (
          <div
            className="fixed bottom-16 right-8 z-50 " // Ensure it's in the right position with high z-index
          >
            <div
              className="back-to-top px-4 hover:bg-[#615d91]"
              onClick={scrollToTop}
            >
              <i className="fa-solid fa-arrow-up text-2xl"></i>
            </div>
          </div>
        )}


      </section>

      <NewFooter/>
    </div>
  )
}
